import { render, staticRenderFns } from "./SqlTabs.vue?vue&type=template&id=3566d460&"
import script from "./SqlTabs.vue?vue&type=script&lang=js&"
export * from "./SqlTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports